import React from "react";

import { Territory } from "@mapmycustomers/shared/types/entity";

import EditPointsTerritoryDrawer from "./components/EditPointsTerritory";
import EditSmartTerritoryDrawer from "./components/EditSmartTerritory";

interface Props {
  onClose: () => void;
  territory: Territory;
}

const EditDrawer: React.FC<Props> = ({ onClose, territory }) => {
  return territory.territoryDetail.type === "points" ? (
    <EditPointsTerritoryDrawer onClose={onClose} territory={territory} />
  ) : (
    <EditSmartTerritoryDrawer onClose={onClose} territory={territory} />
  );
};

export default EditDrawer;
